export const standardiseHoursFormat = (hrsString: string) => {
    const [prettyHrs, prettyMins] = hrsString.split(':')
    .map(x => {
        const xn = Number(x);
        return(xn >= 0 && xn < 10) ? `0${xn}` : `${xn}`
    });
    return `${prettyHrs}:${prettyMins}`;
}
